export default "__VITE_ASSET__DvniqnvX__"